"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Tags_1 = __importDefault(require("../entity/FacetParts/Tags"));
const defaultValue = [
    { value: 'シンプル', count: 123 },
    { value: 'エレガント', count: 1234 },
    { value: 'ルーレット', count: 1234 },
    { value: 'ランキング', count: 1234 },
];
exports.generateTagEntity = (jsons = defaultValue) => Tags_1.default.fromJSON({
    buckets: jsons,
});
